import { observer } from 'mobx-react';
import useStores from '../stores/UseStores';
import React from 'react';
import { ROUTES } from '../Routes';

const TitleHandler = observer((): null => {
  const {
    routeStore: { pathname },
    translateStore: { translate }
  } = useStores();

  React.useEffect(() => {
    updateTitle();
  }, [pathname]);

  const updateTitle = () => {
    const route = ROUTES.find((route) => route.path === pathname);
    const routeLabel = route ? route.pageTitleLabel || 'pageTitle.DEFAULT' : 'pageTitle.404';
    const titleElement = document.querySelector('title');
    if (titleElement) {
      titleElement.innerText = translate(routeLabel);
    }
  };

  return null;
});

export default TitleHandler;
